import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22f2a1ff")

_pushScopeId("data-v-22f2a1ff")
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "line-scale" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.state.isShow)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
})